import Icon from '../../components/Icon.vue'

Icon.register({"regular/moon":{"width":512,"height":512,"paths":[{"d":"M279.1 512C357.9 512 430.1 476.2 478 417.2 506.2 382.4 475.4 331.5 431.7 339.8 349.4 355.5 273.5 292.6 273.5 209 273.5 160.6 299.5 116.7 340.9 93.2 379.6 71.1 369.9 12.4 325.9 4.3A257.9-257.9 0 0 1 279.1 0C137.8 0 23.1 114.6 23.1 256 23.1 397.4 137.7 512 279.1 512zM279.1 48C292.1 48 304.8 49.2 317.2 51.5 262.4 82.6 225.5 141.5 225.5 209 225.5 322.9 329.1 408.2 440.7 387 402.6 434 344.4 464 279.1 464 164.3 464 71.1 370.9 71.1 256S164.3 48 279.1 48z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/moon.js
// module id = IiC7
// module chunks = 0